<template>
    <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center" style="z-index:999999;">
        <div class="fixed inset-0 transition-opacity" @click="$emit('close')">
            <div class="absolute inset-0 bg-black opacity-75"></div>
        </div>
        <div class="bg-white shadow-xl transform transition-all sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline" >
            <div class="bg-white px-4 pt-5 pb-4 sm:p-4 sm:pb-4">
                <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                    <button type="button" class="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close" @click="$emit('close')">
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div class="sm:flex sm:items-start border-b border-gray-400">
                    <div class="mt-3 text-center sm:mt-0 sm:text-left">
                        <h3 class="text-lg leading-6 font-medium text-black pb-2" id="modal-headline">
                            <slot name="heading">Send SMS</slot>
                        </h3>
                    </div>
                </div>
                <ValidationObserver ref="form" v-slot="{ invalid }">
                    <div class="flex md:flex-row sm:flex-col">
                        <div class="w-full mt-2 grid grid-cols-1 row-gap-1 col-gap-4 sm:grid-cols-12">
                            <div class="col-span-12 bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" role="alert" v-show="invalid && submitted" >Please complete all required fields</div>
                            <div class="col-span-12 bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" v-if="errorMessage">{{ errorMessage }}</div>
                            <div class="col-span-12 text-sm">
                                <strong class="pr-2">To:</strong> {{ to.name }}
                                <input-text v-if="loaded"
                                    type="text"
                                    class="font-light py-2 px-3 text-sm focus:outline-none disabled:bg-white disabled:opacity-50 inline-block"
                                    name="mobile"
                                    v-model="item.to.number"
                                    :mask="'#### ### ###'"
                                    placeholder="Mobile"/>
                            </div>
                            <input-textarea class="sm:col-span-12"
                                placeholder="Message"
                                name="message"
                                v-model="item.message"
                                ref="message"
                                rules="required"
                                :rows="12"
                                :required="true"
                            />
                            <div class="w-full block col-span-12 mt-2">
                                <small :class="{'text-red-600': smsExceedsMaximumMessageLength}">Characters: {{ item.message ? item.message.length : 0 }} / {{ maximumMessageLength }}</small>
                            </div>
                            <div v-if="smsContainsUnicodeCharacters && smsExceedsMaximumMessageLength" class="w-full block col-span-12 mt-2 bg-yellow-200 border border-yellow-400 rounded p-3 text-yellow-800 text-sm">
                                <font-awesome-icon class="mr-2" :icon="['fas', 'info']" /> Your message contains unicode characters and exceeds the maximum message length. If you would like to send a longer message, please remove the unicode characters.
                            </div>
                        </div>
                    </div>
                </ValidationObserver>
            </div>
            <div class="bg-gray-200 px-4 py-3 sm:px-4 sm:flex sm:flex-row-reverse">
                <span class="flex flex-grow justify-end">
                    <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto ml-2">
                        <button
                            type="button"
                            class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-default-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-default-700 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-75 disabled:cursor-not-allowed"

                            :disabled="smsExceedsMaximumMessageLength"
                            @click="submit()"
                        >
                            <slot name="delete-button">Send</slot>
                         </button>
                     </span>
                    <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto ml-2">
                        <button type="button" class="inline-flex justify-center w-full border border-gray-500 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            @click="$emit('close')">
                        Cancel
                        </button>
                    </span>
                </span>
                <span class="items-start w-1/2">
                    <input-select class="col-span-4"
                        label=""
                        name="template"
                        placeholder="Insert Template"
                        return="value"
                        :options="options.templates"
                        v-model="template"
                        @input="insertTemplate"
                        ref="template_select"
                        position="top"
                    />
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "SmsModal",
        props: {
            to: { required: true, default: null },
            model: { required: false, default: null },
            id: { required: false, default: null },
            meta: { required: false, default: null }
        },
        beforeMount() {
              axios.get(process.env.VUE_APP_API_URL + '/templates', {
                  params: {
                      sortColumn: 'name',
                      sortDir: 'ASC'
                  }
              }).then(response => {
                  this.templates = response.data;
                  this.options.templates = this.templates.map(template => {
                      return { label: template.name, value: template.id }
                  })
              })
        },
        mounted() {
            document.body.className = 'overflow-hidden';

            if (this.to){
                this.item.to = this.to;
                this.loaded = true;
            }
        },
        data: function () {
            return {
                item: {},
                submitted: false,
                errorMessage: '',
                templates: [],
                options: {
                    templates: []
                },
                selectedTemplate: null,
                template: null,
                loaded: false
            }
        },
        computed: {
            smsContainsUnicodeCharacters() {
                return /[^\u0000-\u00ff]/.test(this.item.message)
            },
            maximumMessageLength() {
                return this.smsContainsUnicodeCharacters ? 402 : 918
            },
            smsExceedsMaximumMessageLength() {
              return (this.item.message?.length ?? 0) > this.maximumMessageLength
            }
        },
        methods: {
            insertTemplate: function (payload) {
                if (payload) {
                    this.selectedTemplate = this.templates.find(template => template.id === payload)

                    if (this.meta.first){
                        this.selectedTemplate.content = this.selectedTemplate.content.replace(/{first}/g, this.meta.first)
                    }

                    if (this.meta.last){
                        this.selectedTemplate.content = this.selectedTemplate.content.replace(/{last}/g, this.meta.last)
                    }

                    if (this.meta.mobile){
                        this.selectedTemplate.content = this.selectedTemplate.content.replace(/{mobile}/g, this.meta.mobile)
                    }

                    if (this.meta.full_address){
                        this.selectedTemplate.content = this.selectedTemplate.content.replace(/{address}/g, this.meta.full_address)
                    }

                    if (this.meta.submissionID){
                        this.selectedTemplate.content = this.selectedTemplate.content.replace(/{submission-id}/g, this.meta.submissionID)
                    }

                    if (this.meta.status){
                        this.selectedTemplate.content = this.selectedTemplate.content.replace(/{status}/g, this.meta.status)
                    }

                    if (this.meta.amount){
                        this.selectedTemplate.content = this.selectedTemplate.content.replace(/{amount}/g, this.meta.amount)
                    }

                    if (this.meta.supplier){
                        this.selectedTemplate.content = this.selectedTemplate.content.replace(/{supplier}/g, this.meta.supplier)
                    }

                    this.item.message = this.selectedTemplate.content

                    this.$refs.message.$refs.message.focus()
                    this.$refs.message.$refs.message.blur()
                    this.$refs.message.$refs.message.focus()

                    this.selectedTemplate = null;
                    this.$refs.template_select.clearSelect()
                }
            },
            submit: function () {
                this.$store.commit('TOGGLE_BACKDROP', {open: true});

                this.submitted = false;

                this.$refs.form.validate().then(success => {
                    if (!success) {
                        this.submitted = true;
                        return;
                    }

                    this.submitted = true;
                    this.errorMessage = '';

                    let _url = process.env.VUE_APP_API_URL + '/sms/send';
                    let _method = 'POST';

                    axios({
                        method: _method,
                        url: _url,
                        data: {
                            to: this.item.to,
                            message: this.item.message,
                            model: this.model,
                            id: this.id
                        }
                    }).then(response => {
                        if (response.data.success) {
                            this.$notify({
                                group: 'main',
                                type: 'success',
                                title: 'Success',
                                text: response.data.message,
                                duration: 5000
                            });

                            this.$emit('sent');
                        } else {
                            if (response.data.message) {
                                this.errorMessage = response.data.message;
                            }
                        }
                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.errorMessage = 'An error occurred. Please contact the System Administrator.';
                        }
                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    });
                });
            },
        },
    }
</script>

<style scoped>

</style>
